export default () => {
    let pagefilterselect = document.querySelector("#page_filter_select");
    let pagefilterbutton = document.querySelector("#page_filter_button");
    if (pagefilterbutton !== null) {
        pagefilterbutton.addEventListener("click", function (e) {
            var value = pagefilterselect.value;
            window.location = value;
        });
    }
};

jQuery(document).ready(function ($) {
    // Handle .less-margin-bottom
    $(".less-margin-bottom").each(function () {
        const marginBottomRaw = $(this).css("margin-bottom");

        if (marginBottomRaw.length && parseInt(marginBottomRaw) > 0) {
            const marginBottom = parseInt(marginBottomRaw);
            const lessMarginBottom = Math.floor(
                marginBottom - marginBottom * 0.5
            );

            $(this).css({
                "margin-bottom": lessMarginBottom + "px",
            });
        }
    });

    $(".category-filter").change(function () {
        //window.location.href = $(".category-filter").value;
        window.location = $(".category-filter").val();
    });
    /*
    $('#category-filter a').on('click', function(e) {
        e.preventDefault();
        var category = $(this).data('cat');
        var searchQuery = $('#s').val(); // Get the search query

        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                action: 'filter_posts',
                category: category,
                search_query: searchQuery, // Pass the search query
            },
            success: function(response) {
                $('#blog-listing').html(response);
            },
        });
    });

    $('#searchform').on('submit', function(e) {
        e.preventDefault();
        var searchQuery = $('#s').val();
        var category = $('#category-filter .current-cat a').data('cat');

        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                action: 'filter_posts',
                category: category,
                search_query: searchQuery,
            },
            success: function(response) {
                $('#blog-listing').html(response);
            },
        });
    });
    */
});
